// File: src/components/Navbar.jsx
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logoImg from '../assets/avt.png';

// --- ICONS SVG (Giữ nguyên) ---
const IconList = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>;
const IconPeople = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const IconQuiz = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line></svg>;
const IconLock = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>;
const IconLogout = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>;
const IconStar = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>;
const IconCheck = () => <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#10B981' }}><polyline points="20 6 9 17 4 12"></polyline></svg>;
const IconRobot = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path><line x1="12" y1="16" x2="12" y2="16.01"></line><line x1="8" y1="16" x2="8" y2="16.01"></line><line x1="16" y1="16" x2="16" y2="16.01"></line></svg>;
const IconEye = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>;
const IconSchool = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c3 3 9 3 12 0v-5" /></svg>;

export default function Navbar() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';
  const [isVisible, setIsVisible] = useState(true); 
  const lastScrollY = useRef(0); 

  // Notification State
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotiDropdown, setShowNotiDropdown] = useState(false);
  const notiRef = useRef(null);

  const PlanBadge = ({ plan }) => {
    if (plan === 'pro') {
      return (
        <span className="ml-2 px-1.5 py-0.5 rounded text-[10px] font-bold bg-blue-100 text-blue-700 border border-blue-200 align-middle">
          PRO
        </span>
      );
    }
    if (plan === 'premium' || plan === 'business_pro' || plan === 'business_premium') {
      return (
        <span className="ml-2 px-1.5 py-0.5 rounded text-[10px] font-bold bg-yellow-100 text-yellow-700 border border-yellow-300 align-middle shadow-sm">
          {plan === 'premium' ? 'PREMIUM' : (plan === 'business_premium' ? 'BIZ PREM' : 'BIZ PRO')}
        </span>
      );
    }
    return null;
  };

  // --- 1. HÀM LOAD USER ---
  const fetchUserIdentity = async () => {
    const token = localStorage.getItem('skillmatch_token');
    if (!token) {
      setUser(null);
      return;
    }
    try {
      const res = await fetch(`${API_URL}/api/users/profile`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const userData = await res.json();
        setUser(userData);
      } else {
        localStorage.removeItem('skillmatch_token');
        setUser(null);
      }
    } catch (error) {
      console.error("Lỗi load user:", error);
    }
  };

  // --- 2. HÀM LOAD THÔNG BÁO ---
  const fetchNotifications = async () => {
    const token = localStorage.getItem('skillmatch_token');
    if (!token) return;

    try {
      const res = await fetch(`${API_URL}/api/notifications`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (res.ok) {
        const data = await res.json();
        if (data && data.notifications) {
          setNotifications(data.notifications);
          setUnreadCount(data.unreadCount || 0);
        } else if (Array.isArray(data)) {
          setNotifications(data);
          setUnreadCount(data.filter(n => !n.isRead).length);
        }
      }
    } catch (error) {
      console.error("Lỗi tải thông báo:", error);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 15000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    fetchUserIdentity();

    const handleAuthChange = () => {
      console.log("♻️ Navbar nhận tín hiệu: Reload User Data");
      setTimeout(() => {
        fetchUserIdentity();
      }, 500);
    };

    window.addEventListener('auth-change', handleAuthChange);
    return () => window.removeEventListener('auth-change', handleAuthChange);
  }, []);

  const handleBellClick = async () => {
    const newShowNoti = !showNotiDropdown;
    setShowNotiDropdown(newShowNoti);

    if (newShowNoti && unreadCount > 0) {
      setUnreadCount(0);
      setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));

      try {
        const token = localStorage.getItem('skillmatch_token');
        await fetch(`${API_URL}/api/notifications/read-all`, {
          method: 'PUT',
          headers: { 'Authorization': `Bearer ${token}` }
        });
      } catch (error) {
        console.error("Lỗi đánh dấu đã đọc:", error);
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setScrolled(currentScrollY > 20);

      if (currentScrollY > lastScrollY.current && currentScrollY > 80) {
        setIsVisible(false);
        setIsMenuOpen(false);
        setShowNotiDropdown(false);
      } else {
        setIsVisible(true);
      }

      lastScrollY.current = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll);

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
      if (notiRef.current && !notiRef.current.contains(event.target)) {
        setShowNotiDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const handleNotificationClick = async (noti) => {
    setShowNotiDropdown(false);
    if (noti.link) navigate(noti.link);
    if (!noti.isRead) {
      try {
        const updatedNotis = notifications.map(n => n._id === noti._id ? { ...n, isRead: true } : n);
        setNotifications(updatedNotis);
        setUnreadCount(prev => Math.max(0, prev - 1));

        await fetch(`${API_URL}/api/notifications/${noti._id}/read`, {
          method: 'PUT',
          headers: { 'x-auth-token': localStorage.getItem('skillmatch_token') }
        });
      } catch (err) { console.error("Mark read error:", err); }
    }
  };

  const handleToggleNoti = () => {
    const newState = !showNotiDropdown;
    setShowNotiDropdown(newState);
  };

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem('skillmatch_token');
      if (token) {
        await fetch(`${API_URL}/api/auth/logout`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
          }
        });
      }
    } catch (error) {
      console.error("Lỗi đăng xuất server:", error);
    } finally {
      localStorage.removeItem('skillmatch_token');
      localStorage.removeItem('token');
      setUser(null);
      setIsMenuOpen(false);
      navigate('/login');
    }
  };

  const getDisplayName = () => user?.profile?.fullName || user?.profile?.companyName || user?.fullName || user?.email?.split('@')[0] || 'User';
  const getInitial = () => getDisplayName().charAt(0).toUpperCase();
  const isActive = (path) => location.pathname === path || (location.pathname.includes(path) && path !== '/');
  const userIdDisplay = user && user._id ? user._id.slice(-6).toUpperCase() : (user && user.id ? user.id.slice(-6).toUpperCase() : '---');

  const goToProfile = () => {
    setIsMenuOpen(false);
    navigate(user.role === 'business' ? "/business/profile" : "/candidate/profile");
  }
  
  const guestLinks = [
    { name: 'Việc làm', path: '/jobs' },
    { name: 'Công ty', path: '/companies' },
    { name: 'Bài Test', path: '/tests' },
    { name: 'Blog', path: '/blog' }
  ];

  const businessLinks = [
    { name: 'Tổng quan', path: '/business/dashboard' },
    { name: 'Tuyển dụng', path: '/business/jobs' },
    { name: 'Ứng viên', path: '/business/candidates' },
    { name: 'Kho Test', path: '/business/tests' }
  ];

  const navItems = (user && user.role === 'business') ? businessLinks : guestLinks;

  const getLink = (path) => {
    if (!user) return path;
    if (user.role === 'candidate' && path === '/') return '/candidate';
    if (user.role === 'candidate') return `/candidate${path}`;
    return path;
  };

  const handleMarkAllRead = async () => {
    try {
      const updatedNotis = notifications.map(n => ({ ...n, isRead: true }));
      setNotifications(updatedNotis);
      setUnreadCount(0);

      const token = localStorage.getItem('skillmatch_token');
      await fetch(`${API_URL}/api/notifications/read-all`, {
        method: 'PUT',
        headers: { 'x-auth-token': token }
      });
    } catch (err) {
      console.error("Lỗi đánh dấu tất cả:", err);
    }
  };

  const notificationLink = user?.role === 'business' ? '/business/notifications' : '/candidate/notifications';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-transform duration-300 ease-in-out 
        ${isVisible ? 'translate-y-0' : '-translate-y-full'} 
        ${scrolled ? 'glass-header py-3' : 'bg-white/50 backdrop-blur-md py-4 border-b border-transparent'}`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <button
          className="md:hidden p-2 text-gray-600 bg-white/80 rounded-lg backdrop-blur-md border border-gray-200"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <span className="material-symbols-outlined text-xl">menu</span>
        </button>

        {/* LOGO */}
        <Link to={getLink('/')} className="flex items-center gap-3 group decoration-0">
          <div className="relative w-9 h-9 md:w-10 md:h-10 flex items-center justify-center">
            <div className="absolute inset-0 bg-blue-500/30 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

            <img
              src={logoImg}
              alt="SkillMatch Logo"
              className="w-9 h-9 object-contain drop-shadow-md filter brightness-110 
                 transform scale-[1.3] 
                 transition-transform duration-300 
                 group-hover:scale-[1.5] group-hover:rotate-3"
            />
          </div>

          <span className="text-xl md:text-2xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-gray-900 to-blue-700 tracking-tight transition-all duration-300 group-hover:from-blue-700 group-hover:to-indigo-600 pb-1">
            SkillMatch
          </span>
        </Link>

        {/* MENU LINKS */}
        <div className="hidden md:flex items-center gap-8 bg-white/50 px-6 py-2 rounded-full border border-gray-100 shadow-sm backdrop-blur-sm">
          {navItems.map((item, idx) => (
            <Link key={idx} to={getLink(item.path)} className={`text-sm font-medium transition-colors ${isActive(item.path) ? 'text-blue-600 font-bold' : 'text-gray-500 hover:text-blue-600'}`}>
              {item.name}
            </Link>
          ))}
          
          {/* CHỈ HIỂN THỊ GÓC HỌC TẬP CHO CÁC TÀI KHOẢN KHÔNG PHẢI DOANH NGHIỆP */}
          {user?.role !== 'business' && (
            <Link to="/student" className="student-nav-item">
              <IconSchool />
              <span>Góc học tập</span>
              <div className="student-badge">MỚI</div>
            </Link>
          )}
        </div>

        {/* ACTIONS */}
        <div className="flex items-center gap-4">
          {user ? (
            <div className="flex items-center gap-4">

              {/* 1. KHỐI THÔNG BÁO */}
              <div className="relative" ref={notiRef}>
                <button onClick={handleBellClick} className="relative p-2 text-gray-600 hover:bg-gray-100 rounded-full transition-colors">
                  <span className={`material-symbols-outlined ${showNotiDropdown ? 'text-blue-600' : ''}`}>notifications</span>
                  {unreadCount > 0 && (
                    <span className="absolute top-0 right-0 w-4 h-4 bg-red-500 text-white text-[10px] flex items-center justify-center rounded-full font-bold border-2 border-white shadow-sm">
                      {unreadCount > 9 ? '9+' : unreadCount}
                    </span>
                  )}
                </button>

                {showNotiDropdown && (
                  <div className="absolute right-0 top-12 w-96 bg-white shadow-2xl rounded-2xl border border-gray-100 overflow-hidden z-50 animate-fade-up ring-1 ring-black/5">
                    <div className="p-4 border-b border-gray-50 flex justify-between items-center bg-white sticky top-0 z-10">
                      <span className="font-bold text-gray-800 text-lg">Thông báo</span>
                      <button
                        onClick={handleMarkAllRead}
                        className="text-xs text-blue-600 font-medium cursor-pointer hover:underline bg-transparent border-none"
                      >
                        Đánh dấu tất cả đã đọc
                      </button>
                    </div>
                    <div className="max-h-[400px] overflow-y-auto custom-scrollbar bg-gray-50/30">
                      {notifications.length > 0 ? notifications.map(noti => (
                        <div
                          key={noti._id}
                          onClick={() => handleNotificationClick(noti)}
                          className={`p-4 border-b border-gray-100 hover:bg-blue-50/50 cursor-pointer transition-colors relative group ${!noti.isRead ? 'bg-white' : 'bg-gray-50/30'}`}
                        >
                          <div className="flex gap-4">
                            <div className={`mt-1.5 w-2.5 h-2.5 rounded-full flex-shrink-0 ${!noti.isRead ? 'bg-blue-600 shadow-sm' : 'bg-transparent'}`}></div>
                            <div className="flex-1">
                              <p className={`text-sm ${!noti.isRead ? 'font-bold text-gray-900' : 'font-medium text-gray-600'}`}>
                                {noti.title}
                              </p>
                              <p className="text-sm text-gray-500 mt-1 leading-relaxed line-clamp-2 group-hover:text-gray-700 transition-colors">
                                {noti.message}
                              </p>
                              <p className="text-[11px] text-gray-400 mt-2 font-medium">
                                {new Date(noti.createdAt).toLocaleString('vi-VN', {
                                  hour: '2-digit', minute: '2-digit',
                                  day: '2-digit', month: '2-digit', year: 'numeric'
                                })}
                              </p>
                            </div>
                          </div>
                        </div>
                      )) : (
                        <div className="p-10 text-center text-gray-400 flex flex-col items-center">
                          <span className="material-symbols-outlined text-4xl mb-3 text-gray-300">notifications_off</span>
                          <p className="text-sm">Chưa có thông báo nào</p>
                        </div>
                      )}
                    </div>
                    <div className="p-2 border-t border-gray-100 bg-white text-center">
                      <Link to={notificationLink} className="text-xs font-semibold text-blue-600 hover:underline block py-1">
                        Xem tất cả
                      </Link>
                    </div>
                  </div>
                )}
              </div>

              {/* 2. USER DROPDOWN */}
              <div className="relative" ref={menuRef}>
                <div className="flex items-center gap-3 cursor-pointer p-1 pr-3 rounded-full hover:bg-gray-100/50 transition-all border border-transparent hover:border-gray-200" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                  <div className="w-9 h-9 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 p-[2px]">
                    <div className="w-full h-full rounded-full bg-white flex items-center justify-center overflow-hidden">
                      {user.profile?.avatar ? <img src={user.profile.avatar} alt="avt" className="w-full h-full object-cover" /> : <span className="text-blue-600 font-bold text-sm">{getInitial()}</span>}
                    </div>
                  </div>
                  <span className="text-sm font-semibold text-gray-700 max-w-[200px] truncate hidden lg:block">{getDisplayName()}</span>
                  <svg className={`w-4 h-4 text-gray-400 transition-transform ${isMenuOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                </div>

                {isMenuOpen && (
                  <div className="absolute right-0 top-14 w-92 max-h-[85vh] overflow-y-auto custom-scrollbar bg-white rounded-2xl shadow-xl border border-gray-100 animate-fade-up ring-1 ring-black/5">
                    {/* HEAD */}
                    <div
                      onClick={goToProfile}
                      className="p-5 bg-gradient-to-br from-blue-50 to-indigo-50 border-b border-blue-100 flex items-center gap-4 cursor-pointer hover:bg-blue-100/50 transition-colors"
                    >
                      <div className="w-12 h-12 rounded-full bg-white p-[2px] shadow-sm flex-shrink-0">
                        <div className="w-full h-full rounded-full bg-gray-100 flex items-center justify-center overflow-hidden">
                          {user.profile?.avatar ? <img src={user.profile.avatar} alt="avt" className="w-full h-full object-cover" /> : <span className="text-blue-600 font-bold text-lg">{getInitial()}</span>}
                        </div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="font-bold text-gray-900 truncate flex items-center">
                          {getDisplayName()}
                          <PlanBadge plan={user.subscription?.plan} />
                        </h4>
                        <div className="flex items-center gap-1 mt-0.5">
                          <IconCheck /> <span className="text-[11px] font-semibold text-emerald-600">Tài khoản xác thực</span>
                        </div>
                        <p className="text-[11px] text-gray-500 mt-1 truncate font-mono">ID: {userIdDisplay} • {user.email}</p>
                      </div>
                    </div>

                    {/* BODY */}
                    <div className="p-2">
                      <div className="mb-2">
                        <div className="px-4 py-2 text-[11px] font-bold text-gray-400 uppercase tracking-wider">
                          {user.role === 'business' ? 'Quản lý tuyển dụng' : 'Quản lý hồ sơ'}
                        </div>
                        {user.role === 'business' ? (
                          <>
                            <Link to="/business/jobs" className="dropdown-link"><span className="icon-box"><IconList /></span> Tin tuyển dụng đã đăng</Link>
                            <Link to="/business/candidates" className="dropdown-link"><span className="icon-box"><IconPeople /></span> Hồ sơ ứng viên</Link>
                            <Link to="/business/tests" className="dropdown-link"><span className="icon-box"><IconQuiz /></span> Kho bài kiểm tra</Link>
                          </>
                        ) : (
                          <>
                            <Link to="/candidate/saved-jobs" className="dropdown-link"><span className="icon-box"><IconList /></span> Việc làm đã lưu</Link>
                            <Link to="/candidate/test-history" className="dropdown-link"><span className="icon-box"><IconQuiz /></span> Bài test đã làm</Link>
                            <Link to="/candidate/following" className="dropdown-link"><span className="icon-box"><IconStar /></span> Công ty đã theo dõi</Link>
                            <Link to="/candidate/mock-interview" className="dropdown-link"><span className="icon-box"><IconRobot /></span> Phỏng vấn thử AI</Link>
                            <Link to="/candidate/my-interviews" className="dropdown-link">
                              <span className="icon-box"><span className="material-symbols-outlined">calendar_month</span></span> Lịch phỏng vấn
                            </Link>
                            <Link to="/candidate/who-viewed-me" className="dropdown-link"><span className="icon-box"><IconEye /></span> Người đã xem hồ sơ</Link>

                          </>
                        )}
                      </div>

                      <div className="h-px bg-gray-100 my-1 mx-3"></div>

                      <div className="mb-2">
                        <div className="px-4 py-2 text-[11px] font-bold text-gray-400 uppercase tracking-wider">Tài khoản & Cài đặt</div>

                        {(user.role === 'candidate' || user.role === 'business') && (
                          <Link to={`/${user.role}/upgrade-account`} className="dropdown-link group">
                            <span className="icon-box group-hover:bg-yellow-100 group-hover:text-yellow-600 transition-colors">
                              <span className="material-symbols-outlined text-yellow-500">workspace_premium</span>
                            </span>
                            <span className="text-yellow-700 font-bold">
                              {user.role === 'business' ? 'Nâng cấp Gói Doanh nghiệp' : 'Nâng cấp tài khoản VIP'}
                            </span>
                          </Link>
                        )}

                        <Link to="candidate/change-password" className="dropdown-link"><span className="icon-box"><IconLock /></span> Đổi mật khẩu</Link>
                      </div>
                    </div>

                    <div className="p-2 border-t border-gray-100 bg-gray-50/50">
                      <button onClick={handleLogout} className="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold text-red-600 rounded-xl hover:bg-red-50 transition-colors">
                        <IconLogout /> Đăng xuất
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <Link to="/login" className="text-sm font-bold text-gray-600 hover:text-blue-600 px-4 py-2 no-underline">Đăng nhập</Link>
              <Link to="/register-business" className="btn-signature px-5 py-2.5 text-sm shadow-lg shadow-blue-500/30 no-underline">Nhà tuyển dụng</Link>
            </div>
          )}
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white border-b border-gray-100 shadow-lg animate-fade-down z-40">
          <div className="flex flex-col p-4 space-y-2">
            {navItems.map((item, idx) => (
              <Link key={idx} to={getLink(item.path)} onClick={() => setIsMobileMenuOpen(false)} className={`px-4 py-3 rounded-lg text-sm font-semibold ${isActive(item.path) ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-gray-50'}`}>
                {item.name}
              </Link>
            ))}
            
            {/* THÊM GÓC HỌC TẬP VÀO MENU MOBILE CHO ỨNG VIÊN */}
            {user?.role !== 'business' && (
              <Link to="/student" onClick={() => setIsMobileMenuOpen(false)} className={`px-4 py-3 rounded-lg text-sm font-semibold flex items-center gap-2 ${isActive('/student') ? 'bg-pink-50 text-pink-600' : 'text-pink-600 hover:bg-pink-50'}`}>
                <IconSchool /> Góc học tập
              </Link>
            )}
          </div>
        </div>
      )}

      <style>{`
       .dropdown-link {
           display: flex; align-items: center; gap: 12px; padding: 10px 16px; margin: 0 8px;
           font-size: 14px; font-weight: 500; color: #374151; text-decoration: none; border-radius: 10px;
           transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
       }
       .dropdown-link:hover { background-color: #EEF2FF; color: #4F46E5; transform: translateX(4px); }
       .icon-box { display: flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 8px; background-color: #F3F4F6; color: #6B7280; transition: all 0.2s; }
       .dropdown-link:hover .icon-box { background-color: #FFFFFF; color: #4F46E5; box-shadow: 0 2px 5px rgba(0,0,0,0.05); }
       .custom-scrollbar::-webkit-scrollbar { width: 4px; }
       .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
       .custom-scrollbar::-webkit-scrollbar-thumb { background: #E5E7EB; border-radius: 10px; }
       .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #D1D5DB; }
       .btn-signature { background: linear-gradient(135deg, #2563EB 0%, #4F46E5 100%); color: white !important; border-radius: 10px; font-weight: 600; transition: all 0.2s ease; }
       .btn-signature:hover { transform: translateY(-1px); filter: brightness(1.1); }
       .student-nav-item {
            display: flex; align-items: center; gap: 6px;
            padding: 6px 14px;
            border-radius: 20px;
            text-decoration: none;
            font-weight: 700;
            font-size: 14px;
            position: relative;
            background: linear-gradient(135deg, #FFF0F5 0%, #F0F9FF 100%);
            color: #DB2777; /* Hồng đậm */
            border: 1px solid #FCE7F3;
            transition: all 0.3s ease;
            margin-left: 8px;
        }
        .student-nav-item svg { color: #D946EF; } /* Icon tím */
        .student-nav-item:hover {
            background: linear-gradient(135deg, #FCE7F3 0%, #E0F2FE 100%);
            transform: translateY(-2px);
            box-shadow: 0 4px 10px rgba(219, 39, 119, 0.15);
        }
        .student-badge {
            position: absolute;
            top: -8px; right: -5px;
            background: linear-gradient(90deg, #EC4899, #8B5CF6);
            color: white;
            font-size: 9px;
            font-weight: 800;
            padding: 2px 6px;
            border-radius: 10px;
            box-shadow: 0 2px 4px rgba(236, 72, 153, 0.3);
            animation: bounce 2s infinite;
        }
       @keyframes fadeUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
       .animate-fade-up { animation: fadeUp 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
     `}</style>
    </nav>
  );
}